import StoreName    from '../../Shared/Constants/StoreName';
import IPlayerState from '../../Shared/Interfaces/IPlayerState';

import Config               from './Config';
import IConfig              from './Interfaces/IConfig';
import IConfigStore         from './Interfaces/IConfigStore';
import resolveConfigActions from './resolveConfigActions';

const createMediaStore = (
    state: IPlayerState,
    initialValue?: IConfig
): IConfigStore =>
    state.createStore({
        name: StoreName.CONFIG,
        model: Config,
        actions: resolveConfigActions,
        containsNestedProps: true
    }, initialValue);

export default createMediaStore;